// @flow

export const isBrowser = () => typeof window !== 'undefined';

// Chrome 1+
export const isChrome = () => isBrowser() && !!window.chrome;

export const setScrollRestorationManual = () => {
  // https://developers.google.com/web/updates/2015/09/history-api-scroll-restoration
  if ('scrollRestoration' in window.history) {
    // Try / catch for scrollRestoration writable: https://github.com/taion/scroll-behavior/issues/126
    try {
      // Back off, browser, I got this...
      window.history.scrollRestoration = 'manual';
    } catch (e) {
      /* silence */
    }
  }
};
